import React from "react";
import { fileUrl } from "@/lib/apiClient";
import { cn } from "@/lib/utils";

// Consistent student/user avatar — shows photo or a clean gradient initials placeholder.
export function Avatar({ src, name = "", size = 40, className = "", testId }) {
  const url = src ? (src.startsWith("http") ? src : fileUrl(src)) : null;
  const style = { width: size, height: size, fontSize: Math.max(12, Math.round(size * 0.4)) };
  if (url) {
    return <img src={url} alt={name || "avatar"} style={style} className={cn("rounded-full object-cover bg-secondary", className)} data-testid={testId} />;
  }
  return (
    <div style={style} data-testid={testId}
      className={cn("rounded-full bg-gradient-to-br from-teal to-brandgreen text-white font-semibold flex items-center justify-center select-none", className)}>
      {(name?.trim()?.[0] || "U").toUpperCase()}
    </div>
  );
}
